import ReactDOM from 'react-dom';

import { getYMapsInstance, scale } from './helpers';
import { iconLayout } from './assets/clusterer_icon';
import { defaultSettings } from './settings';
import { baloonMinDesktopHeight, baloonMinMobileHeight } from './constants';
import { pinDict } from './assets/placemark_pins';

export class ComponentsInitor {
  static points = [];

  constructor({ ...props }) {
    this.props = { ...props };
    this.ymaps = getYMapsInstance();
    this.map = null;
    this.clusterer = null;
    this.center = null;
    this.isMobile = this.props.isMobile;
    this.mapId = this.props.mapId;
    this.pins = this.props.pins;
  }

  Map = () => {
    const { points, center, hasClusters, customMapState, customMapOptions, mobileOptions } =
      this.props;

    const mobileBaloonHeight = (mobileOptions || {}).balloonMinHeight || baloonMinMobileHeight;

    // take center coords of map
    this.center = !center ? this.getCenter(points) : center;
    const [startLatitude, startLongitude] = this.center;

    // default map settings and options
    const mapOptions = Object.assign(defaultSettings.mapOptions, customMapOptions || {});
    const mapState = Object.assign(defaultSettings.mapState, customMapState || {});

    mapState.center = this.center;

    // init map and add settings
    this.map = new this.ymaps.Map(
      `${this.mapId}`,
      {
        center: [startLatitude, startLongitude],
        ...mapState,
      },
      {
        ...mapOptions,
      },
    );
    // ===
    if (this.isMobile) {
      this.map.options.set('balloonPanelMaxMapArea', Infinity);
      this.map.options.set('balloonMinHeight', mobileBaloonHeight);
    }
    // get collection of placemarks to add
    const placemarks = points.map((point) => this.Placemark(point));
    // ===
    if (hasClusters) {
      // clusterer added
      this.clusterer = this.Clusterer();
      // add to clusterer
      this.clusterer.add(placemarks);
      // ===
      this.map.geoObjects.add(this.clusterer);
    } else {
      placemarks.forEach((placemark) => this.map.geoObjects.add(placemark));
    }
  };

  getCenter = (points) => {
    let latitudeSum = 0;
    let longitudeSum = 0;
    let pointsCount = 0;

    points.forEach((item) => {
      if (!!item.latitude && !!item.longitude) {
        latitudeSum += parseFloat(item.latitude);
        longitudeSum += parseFloat(item.longitude);
        pointsCount += 1;
      }
    });

    const centerLat = pointsCount && latitudeSum ? latitudeSum / pointsCount : 55.751999;
    const centerLon = pointsCount && longitudeSum ? longitudeSum / pointsCount : 37.617734;

    return [centerLat, centerLon];
  };

  updateMap = (points, prevIsMobile, isMobile) => {
    if (this.clusterer) {
      this.updateClusterer(points);
    } else if (this.map) {
      this.updateMapPoints(points);
    }

    if (points && (points.length || 0) > 0 && this.map && this.map.setCenter && this.getCenter) {
      this.getCenter(points);
      (this.map || {}).setCenter(this.getCenter(points));
    }
    if (prevIsMobile !== isMobile && this.map) {
      this.toogleBaloonView(isMobile);
      this.toogleIsMobile(isMobile);
    }
  };

  toogleBaloonView = (stickToBottom) => {
    const { customMapOptions, mobileOptions } = this.props;

    const mobileBaloonHeight = (mobileOptions || {}).balloonMinHeight || baloonMinMobileHeight;
    const desktopBaloonHeight = (customMapOptions || {}).balloonMinHeight || baloonMinDesktopHeight;

    this.map.options.set('balloonPanelMaxMapArea', stickToBottom ? Infinity : 0);
    this.map.options.set(
      'balloonMinHeight',
      stickToBottom ? mobileBaloonHeight : desktopBaloonHeight,
    );
  };

  toogleIsMobile = (isMobile) => {
    if (this.isMobile !== isMobile) {
      this.isMobile = isMobile;
    }
  };

  updateMapPoints = (points) => {
    this.map.geoObjects.removeAll();
    const placemarks = points.map((point) => this.Placemark(point));
    placemarks.forEach((placemark) => this.map.geoObjects.add(placemark));
  };

  updateClusterer = (points) => {
    this.clusterer.removeAll();
    const placemarks = points.map((point) => this.Placemark(point));
    this.clusterer.add(placemarks);
  };

  destroyMap = () => {
    this.map.destroy();
  };

  Placemark = (point) => {
    const { onBaloonClose, onBaloonOpen, customPlacemarkOptions, children } = this.props;
    // default placemark settings
    const placemarkOptions = Object.assign(
      defaultSettings.placemarkOptions,
      customPlacemarkOptions || {},
    );
    // ===
    // coords
    const lat = parseFloat(point.latitude);
    const lon = parseFloat(point.longitude);

    const partner = (point.partner || {}).slug;
    const pointType = (point.point_type || {}).slug;

    const defaultInactiveSvg = (this.pins || {}).default;
    const partnerInactiveSvg = (((this.pins || {}).partners || {})[partner] || {})[pointType];

    const inactiveSvg = (partnerInactiveSvg || defaultInactiveSvg || pinDict).pin;
    const activeSvg = (partnerInactiveSvg || defaultInactiveSvg || pinDict).activePin;

    // inactive pin
    const PinContentLayout = this.ymaps.templateLayoutFactory.createClass(inactiveSvg);

    // active pin
    const PinActiveContentLayout = this.ymaps.templateLayoutFactory.createClass(activeSvg);
    // ===
    // create
    const placemark = new this.ymaps.Placemark(
      [lat, lon],
      {
        balloonContentBody: `<div id='baloon_${lat}_${lon}' />`,
      },
      {
        iconContentLayout: PinContentLayout,
        ...placemarkOptions,
      },
    );
    // change icon
    placemark.events
      .add('balloonopen', (e) => {
        if (onBaloonOpen) {
          onBaloonOpen(e);
        }
        ReactDOM.render(
          children({ point, isMobile: this.isMobile }),
          document.getElementById(`baloon_${lat}_${lon}`),
        );

        e.get('target').options.set('iconContentLayout', PinActiveContentLayout);
        if (this.isMobile) {
          document.getElementById('ya_baloon_wrapper').focus();
          try {
            document.getElementById('ya_baloon_wrapper').scrollIntoViewIfNeeded();
          } catch (err) {
            console.log(err);
          }
          // scrollAnimate(document.getElementById('ya_baloon_wrapper'), null, -330);
        }
      })
      .add('balloonclose', (e) => {
        if (onBaloonClose) {
          onBaloonClose(e);
        }
        e.get('target').options.set('iconContentLayout', PinContentLayout);
      });
    // ===
    return placemark;
  };

  Clusterer = () => {
    // ===
    const { customClustererOptions } = this.props;
    const clustererOptions = Object.assign(
      defaultSettings.clustererOptions,
      customClustererOptions || {},
    );
    // ===
    // here we add filter-function to use it iconLayout and scale to due to points count
    this.ymaps.template.filtersStorage.add('scale', scale);
    // ===
    const ClustererContentLayout = this.ymaps.templateLayoutFactory.createClass(iconLayout);
    // properties.geoObjects.length
    // init clusterer
    return new this.ymaps.Clusterer({
      clusterIconLayout: ClustererContentLayout,
      ...clustererOptions,
    });
  };
}
